import Swal, { SweetAlertResult } from "sweetalert2"

export const ApprovalAlert = async (message:string): Promise<SweetAlertResult<any>> =>
  await Swal.fire({
    title: "Are you sure want to continue?",
    text: message,
    showCancelButton: true,
    confirmButtonText: 'Approve',
    cancelButtonText: 'Cancel',
    customClass: {
      confirmButton: "btn btn-primary",
      cancelButton: "btn btn-error"
    }
  })